const state = {
  loading: false,
  error: null,
  success: null,
  debug: true
}

// getters
const getters = {
  loading (state) {
    return state.loading;
  },
  error (state) {
    return state.error;
  },
  success (state) {
    return state.success
  },
  debug (state) {
    return state.debug;
  },
  loading (state) {
    return state.loading;
  },
}

// actions
const actions = {
  clearError ({ commit }) {
    commit('clearError')
  },
  clearSuccess ({ commit }) {
    commit('clearSuccess')
  }
}

// mutations
const mutations = {
  setLoading (state, payload) {
    // console.log('setLoading', payload);
    state.loading = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  setSuccess (state, payload) {
    state.success = payload
  },
  clearError (state) {
    state.error = null
  },
  clearLoading (state) {
    state.loading = null
  },
  clearSuccess (state) {
    state.success = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
